import type { RouteObject } from "react-router"

import { RootPath } from "@/models/route"

import { LabsGuard } from "./components/labs-guard/labs-guard"
import { LabsPage } from "./pages/labs-page/labs-page"

export const labsRoutes: RouteObject[] = [
  {
    path: RootPath.Labs,
    element: (
      <LabsGuard>
        <LabsPage />
      </LabsGuard>
    ),
  },
]
